import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const ChangePlan = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      d="M13.333 1.333v2.679a6.65 6.65 0 0 0-11.062.59l1.086.782A5.334 5.334 0 0 1 8 2.667a5.34 5.34 0 0 1 5.333 5.339v.011h1.333V1.333h-1.333ZM8 13.333A5.34 5.34 0 0 1 2.667 8H1.333v6.667h1.334v-2.68a6.649 6.649 0 0 0 11.038-.551l-1.086-.782A5.332 5.332 0 0 1 8 13.334Z"
      fill="currentColor"
    />
    <path
      d="M6.444 9.374c.006.007.522.635 1.401.635.575 0 .947-.285.947-.726 0-.43-.513-.586-1.106-.767h-.002c-.86-.264-1.93-.591-1.93-1.918 0-.887.652-1.607 1.63-1.807v-.858H8.66v.868c.92.206 1.375.762 1.394.786l.037.046-.04.042-.844.89-.048-.056c-.004-.006-.43-.506-1.094-.506-.529 0-.77.308-.77.595 0 .43.513.587 1.107.767h.002c.86.264 1.93.591 1.93 1.918 0 .97-.64 1.706-1.674 1.93v.866H7.383v-.837c-1.199-.193-1.81-.96-1.835-.994l-.036-.045.886-.887.046.058Z"
      fill="currentColor"
    />
  </Icon>
));

export default ChangePlan;
